export default __webpack_public_path__ + "static/media/jmeter.320c1d19.svg";